// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3FaNo","paramInput":"JobSimulator_paramInput__1Pdos","input":"JobSimulator_input__2T5mn"};